import { useBucket, useExperimentVariables } from '@mc/experiments-react'
import { logger } from '@mc/next-logger'
import { CONTEST_PROMO_TILE_FLAG } from './constants'
import { ContestPromoConfigProps, ValidatedContestPromoProps } from './types'

export const useContestPromoExp = (
  slug: string,
): {
  showContestExperiment: boolean
  contestPromoProps?: ValidatedContestPromoProps
} => {
  const variables = useExperimentVariables<ContestPromoConfigProps>(
    CONTEST_PROMO_TILE_FLAG,
  )

  const matchingContest = variables?.contestPages?.find(
    (page) => page.slug === slug,
  )

  const bucket = useBucket<'control' | 'variant_1'>(CONTEST_PROMO_TILE_FLAG)
  let showContestExperiment = !!bucket && !!matchingContest

  // For variant_1, validate all required properties exist:
  const isValidContestConfig = !!(
    matchingContest?.content &&
    matchingContest.contestLink &&
    matchingContest.heading &&
    matchingContest.imageUrl
  )

  if (bucket === 'variant_1') {
    showContestExperiment = showContestExperiment && isValidContestConfig

    if (!isValidContestConfig) {
      logger.error(
        `Contest Promo Tile config is invalid for CM slug: ${slug}`,
        matchingContest,
      )
    }
  }

  return {
    showContestExperiment,
    contestPromoProps: isValidContestConfig
      ? (matchingContest as ValidatedContestPromoProps)
      : undefined,
  }
}
